import { Navigate } from "react-router-dom";

import DashboardEcommerce from "../pages/DashboardEcommerce";

import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

import NotificationList from "pages/Notification/NotificationList";
import AdminList from "pages/Admin/AdminList";
import MemberList from "pages/Member/MemberList";
import InfoList from "pages/Info/InfoList";
import ShiftList from "pages/Shift/ShiftList";
import WorkLocation from "pages/WorkLocation/WorkLocation";
import ActivityLocation from "pages/ActivityLocation/ActivityLocation";
import Attendance from "pages/Attendance/Attendance";
import WorkActivities from "pages/WorkActivities/WorkActivities";
import WorkExtension from "pages/WorkExtension/WorkExtension";
import CompanyProperties from "pages/Properties/CompanyProperties/CompanyProperties";
import MenuMemberProperties from "pages/Properties/MenuMember/MenuMemberProperties";
import EventList from "pages/Event/EvenList";
import DetailEventList from "pages/Event/DetailEventList";

import SalaryMaster from "pages/Salary/SalaryData/SalaryMaster";
import InsuranceData from "pages/Salary/InsuranceData/Insurance";
import BenefitData from "pages/Salary/BenefitData/Benefit";
import DeductionData from "pages/Salary/DeductionData/Deduction";
import PayslipList from "pages/Salary/Payslip/PayslipList";
import AddPayslip from "pages/Salary/Payslip/AddPayslip";
import EditPayslip from "pages/Salary/Payslip/EditPayslip";

import LogProduct from "pages/LogBook/Product/LogProduct";
import LogVehicle from "pages/LogBook/Vehicle/LogVehicle";

import DocumentList from "pages/FileManagement/Document/DocumentList";
import CollaborationList from "pages/FileManagement/Collaboration/CollaborationList";

import SuperadminDashboard from "../pages/Superadmin/Dashboard/SuperadminDashboard";
import SuperadminCompanies from "../pages/Superadmin/Company/SuperadminCompanies";
import SuperadminNotification from "../pages/Superadmin/Notification/SuperadminNotification";
import CheckPointPatrolSuper from "../pages/Superadmin/Company/Setting/CheckPointPatrol";
import SuperadminDocumentList from "../pages/Superadmin/ManagementFile/Document/DocumentList";
import HistoryCollaboration from "../pages/Superadmin/ManagementFile/Collaboration/HistoryCollaboration";

export const checkUserRole = () => {
  const userRole = sessionStorage.getItem("userRole");
  return userRole || null;
};

export const isAuthenticated = () => {
  const authUser = sessionStorage.getItem("authUser");
  return authUser !== null;
};

// Superadmin only routes
const superadminRoutes = [
  {
    path: "/superadmin/dashboard",
    component: <SuperadminDashboard />,
    roles: ["superadmin"],
  },
  {
    path: "/superadmin/perusahaan",
    component: <SuperadminCompanies />,
    roles: ["superadmin"],
  },
  {
    path: "/superadmin/notifikasi",
    component: <SuperadminNotification />,
    roles: ["superadmin"],
  },
  {
    path: "/superadmin/perusahaan/konfigurasi-cek-poin/:id",
    component: <CheckPointPatrolSuper />,
    roles: ["superadmin"],
  },
  {
    path: "/superadmin/berkas-perusahaan",
    component: <SuperadminDocumentList />,
    roles: ["superadmin"],
  },
  {
    path: "/superadmin/riwayat-kerja-sama",
    component: <HistoryCollaboration />,
    roles: ["superadmin"],
  },
];

// Admin & Superadmin routes (when viewing company)
const authProtectedRoutes = [
  {
    path: "/dashboard",
    component: <DashboardEcommerce />,
    roles: ["admin", "superadmin"],
  },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/login" />,
  },
  { path: "*", component: <Navigate to="/" /> },

  // Properties (accessible by all authenticated users)
  {
    path: "/properties-perusahaan",
    component: <CompanyProperties />,
    roles: ["admin", "superadmin"],
  },
  {
    path: "/menu-aplikasi",
    component: <MenuMemberProperties />,
    roles: ["admin", "superadmin"],
  },

  // Master Data (MAIN_DATA)
  {
    path: "/admin",
    component: <AdminList />,
    roles: ["admin", "superadmin"],
    menuCategory: "MAIN_DATA",
  },
  {
    path: "/notifikasi",
    component: <NotificationList />,
    roles: ["admin", "superadmin"],
    menuCategory: "MAIN_DATA",
  },
  {
    path: "/info",
    component: <InfoList />,
    roles: ["admin", "superadmin"],
    menuCategory: "MAIN_DATA",
  },
  {
    path: "/shift",
    component: <ShiftList />,
    roles: ["admin", "superadmin"],
    menuCategory: "MAIN_DATA",
  },
  {
    path: "/karyawan",
    component: <MemberList />,
    roles: ["admin", "superadmin"],
    menuCategory: "MAIN_DATA",
  },
  {
    path: "/lokasi-kerja",
    component: <WorkLocation />,
    roles: ["admin", "superadmin"],
    menuCategory: "MAIN_DATA",
  },

  // Activity Location (PATROL_LOCATION)
  {
    path: "/lokasi-aktivitas-pekerjaan",
    component: <ActivityLocation />,
    roles: ["admin", "superadmin"],
    menuCategory: "PATROL_LOCATION",
  },

  // Attendance (ATTENDANCE)
  {
    path: "/absen",
    component: <Attendance />,
    roles: ["admin", "superadmin"],
    menuCategory: "ATTENDANCE",
  },
  {
    path: "/lembur",
    component: <WorkExtension />,
    roles: ["admin", "superadmin"],
    menuCategory: "ATTENDANCE",
  },

  // Work Activities (PATROL)
  {
    path: "/aktivitas-pekerjaan",
    component: <WorkActivities />,
    roles: ["admin", "superadmin"],
    menuCategory: "PATROL",
  },

  // Log Product
  {
    path: "/buku-catatan-barang",
    component: <LogProduct />,
    roles: ["admin", "superadmin"],
    menuCategory: "LOG_BOOK",
  },
  {
    path: "/buku-catatan-kendaraan",
    component: <LogVehicle />,
    roles: ["admin", "superadmin"],
    menuCategory: "LOG_BOOK",
  },

  // EVENT (EVENT)
  {
    path: "/event",
    component: <EventList />,
    roles: ["admin", "superadmin"],
    menuCategory: "EVENT",
  },
  {
    path: "/event/detail/:id",
    component: <DetailEventList />,
    roles: ["admin", "superadmin"],
    menuCategory: "EVENT",
  },

  // Salary Data (SALARY_DATA)
  {
    path: "/data-gaji",
    component: <SalaryMaster />,
    roles: ["admin", "superadmin"],
    menuCategory: "PAYROLL",
  },
  {
    path: "/data-asuransi",
    component: <InsuranceData />,
    roles: ["admin", "superadmin"],
    menuCategory: "PAYROLL",
  },
  {
    path: "/data-keuntungan",
    component: <BenefitData />,
    roles: ["admin", "superadmin"],
    menuCategory: "PAYROLL",
  },
  {
    path: "/data-potongan",
    component: <DeductionData />,
    roles: ["admin", "superadmin"],
    menuCategory: "PAYROLL",
  },
  {
    path: "/slip-gaji",
    component: <PayslipList />,
    roles: ["admin", "superadmin"],
    menuCategory: "PAYROLL",
  },
  {
    path: "/slip-gaji/tambah",
    component: <AddPayslip />,
    roles: ["admin", "superadmin"],
    menuCategory: "PAYROLL",
  },
  {
    path: "/slip-gaji/edit/:id",
    component: <EditPayslip />,
    roles: ["admin", "superadmin"],
    menuCategory: "PAYROLL",
  },
  {
    path: "/berkas-perusahaan",
    component: <DocumentList />,
    roles: ["admin", "superadmin"],
    menuCategory: "MAIN_DATA",
  },
  {
    path: "/riwayat-kerja-sama",
    component: <CollaborationList />,
    roles: ["admin", "superadmin"],
    menuCategory: "MAIN_DATA",
  },
];

const publicRoutes: any = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
];

// Combine all protected routes
const allProtectedRoutes = [...superadminRoutes, ...authProtectedRoutes];

export {
  authProtectedRoutes,
  publicRoutes,
  superadminRoutes,
  allProtectedRoutes,
};
